import React, {Component} from 'react';
import styled from "styled-components";

import AppTitleBar from "./AppTitleBar";
import AppExplore from "./AppExplore";
import AppCurate from "./AppCurate";
import AppStudy from "./AppStudy";
import AppAnimate from "./AppAnimate";

const AppPageWrapper = styled.div`
    font-family: Arial;
`;

const sectionExplore = 'explore';
const sectionCurate = 'curate';
const sectionStudy = 'study';
const sectionAnimate = 'animate';

export class FractoApp extends Component {

    state = {
        selected: sectionExplore
    };

    componentDidMount() {
        document.title = 'fracto-app';
        document.body.style.backgroundColor = "#f0f8ff";
        document.body.style.margin = "0";
    }

    menuSelect = (itemName) => {
        this.setState({selected: itemName});
    }

    render() {
        //console.log(this.props);
        const fractoMenu = [sectionExplore, sectionCurate, sectionStudy, sectionAnimate];
        let section = <div>{this.state.selected + " not defined"}</div>
        switch(this.state.selected) {
            case sectionExplore : section = <AppExplore {...this.props} />; break;
            case sectionCurate : section = <AppCurate />; break;
            case sectionStudy : section = <AppStudy />; break;
            case sectionAnimate : section = <AppAnimate />; break;
            default: section = <div>{"unknown section: " + this.state.selected}"</div>; break;
        }
        return <AppPageWrapper>
            <AppTitleBar
                title={"fracto"}
                menu={fractoMenu}
                callback={this.menuSelect}
                selected={this.state.selected}
            />
            {section}
        </AppPageWrapper>
    }
}

export default FractoApp;
